<template>
  <div class="live-table-content">
    <ul v-show="listlength" class="clearfix live-box">

    	<li v-for="item in liveList" :key="`live${item.id}`">
    		<a href="javascript:;" class="clearfix">
    			<div class="live-cont">
    				<div class="live-title">{{item.liveName}}</div>
    				<div class="live-time-table">
              <img src="../../../assets/img/clock_live.png">
              <div class="live-time-text">{{item.startTime}}</div>
            </div>
    				<div class="live-btn">
    					<div class="live-left">
    						<img :src="item.teacherImg">
    						<div class="live-left-name">{{item.teacherName}}</div>
    					</div>
    					<div class="live-right">
    						<div v-if="item.liveStatus == 2" @click="toLive(item)" class="live-right-btnred">{{item.btnName}}</div>
    						<div v-else-if="item.liveStatus == 1" class="live-right-btngrey">{{item.btnName}}</div>
    						<div v-else-if="item.liveStatus == 3" @click="toLiveBack(item)" class="live-right-btngreen">{{item.btnName}}</div>
    						<div v-else class="live-right-btngrey">{{item.btnName}}</div>
                <div v-show="item.liveStatus==1" class="live-right-number">{{item.watchPeople}}人观看</div>
    					</div>
    				</div>
    			</div>
    		</a>
    	</li>

    </ul>
    <div class="task-pagination" style="text-align: center;" v-show="listlength">
      <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
    </div>
    <nothing v-show="!listlength"></nothing>
  </div>
</template>

<script>
  import {ApiLiveList} from '../../../net/accound/index.js'
  import {getLiveUrl} from '../../../untils/common.js'
  import nothing from '../../../common/nothing.vue'
  export default {
    data: function () {
      return {
        pageNum: 1,
        pageSize: 4,
        total: 0,
        loading: false,
        liveList: []
      }
    },
    props:{
      liveType: Number
    },
    components:{nothing},
    computed: {
      listlength: function () {
        return this.liveList.length
      }
    },
    watch: {
      liveType: function () {
        this.getLiveList()
      }
    },
    methods: {
      getLiveList: function () {
        const prames = {
          liveType: this.liveType,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          platform: 'pc'
        }
        this.loading = true
        ApiLiveList(prames).then(res=>{
          // console.log('直播列表', res)
          const arr = ['', '即将开始', '正在直播', '直播回放', '回放生成中']
          this.liveList = res.pc.details.map(item=>{
            if (item.liveStatus==3 && !item.playUrl) {
              item.liveStatus = 4
            }
            return {
                ...item,
                teacherImg: item.teacherImg || `http://statics.sgn.7east.cn/photo/20201207172318.png`,
                btnName: arr[item.liveStatus]
              }
          })
          this.total = res.pc.total
          this.loading = false
        }).catch(err=>{
          this.loading = false
        })
      },
      handleCurrentChange: function (index) {
        this.pageNum = index
        this.getLiveList()
      },
      toLive: function (item) {
        const liveUrl = getLiveUrl(item.roomIdV2)
        window.open(liveUrl, '_blank')
      },
      toLiveBack: function (item) {
        const { href } = this.$router.resolve({
              path: `liveBackPlayer`,
              query:{lid : item.id}
            });
        window.open(href, '_blank');
      },
    },
    mounted: function () {
      this.getLiveList()
    }
  }
</script>

<style scoped>
  .live-table-content{
    width:850px;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
  }
 .live-table-content ul{
 	margin:0 ;
 	padding:0;
  min-height: 530px;
 }
 .live-table-content ul li{
 list-style-type: none;
 float: left;
 margin-right: 24px;
 margin-bottom: 24px;
 }
 .live-table-content  ul li:nth-child(2n) {margin-right:0;}
 .live-cont{
 	width: 413px;
 	background:#fff;
 	float: left;
 	border-radius: 6px;
 }
 .live-title{
 	margin-top: 30px;
 	margin-left: 15px;
 	margin-right:15px;
 	font-size: 18px;
 	font-weight: bold;
 	color: #252525;
 	overflow: hidden;
 	text-overflow:ellipsis;
 	white-space: nowrap;
 }
 .live-time-table{
 	height: 14px;
 	margin-top: 15px;
 	float: left;
 	width: 100%;
 }
 .live-time-table img{
 	width: 16px;
 	height: 16px;
 	border:none;
 	float: left;
 	margin-left: 15px;
 	margin-right: 10px;;
 }
 .live-time-text{
 	font-size: 16px;
 	float:left;
 	line-height: 16px;
 	color: #7F7F7F;
 }
 .live-left img{
 	width: 36px;
 	height: 36px;
  border-radius: 50%;
 }
 .live-btn{
 	margin-top: 30px;
 	float: left;
 	width: 100%;
 }
 .live-left{
 	margin-left: 15px;
 	margin-bottom: 30px;
 	float: left;
 }
 .live-left-name{
 	font-size: 14px;
 	color: #7f7f7f;
 	margin-top: 5px;
 }
 .live-table-content ul li a{
 	text-decoration: none;
 }
 .live-right{
 	float: right;
 	margin-right: 15px;
 }
 .live-right-btnred{
 	width: 100px;
 	height: 36px;
 	border-radius: 36px;
 	background: #FF1010;
 	color: #fff;
 	text-align: center;
 	line-height: 36px;
 }
 .live-right-number{
 	font-size: 14px;
 	color: #7F7F7F;
 	margin-top: 5px;
  text-align: center;
 }
 .live-right-btngrey{
 	width: 100px;
 	height: 36px;
 	border-radius: 36px;
 	background: #e5e5e5;
 	color: #7f7f7f;
 	text-align: center;
 	line-height: 36px;
 }
 .live-right-btngreen{
 	width: 100px;
 	height: 36px;
 	border-radius: 36px;
 	background: #00B54F;
 	color: #fff;
 	text-align: center;
 	line-height: 36px;
 }
 .task-pagination{
   text-align: center;
   width: 100%;
 }
 .live-box{
   margin-bottom: 20px;
 }
</style>



// WEBPACK FOOTER //
// src/components/AccLive/children/liveList.vue